import { ClearStorage, GetItemFromStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import { decryptCodes, encryptCodes, getToken, hassAccess } from "../../base/utils";
import { ROLES, config, getDynamicLocation } from "../../base/constant";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AgentStateAction } from "../../store/slices/agent-status/agent_state";
import { ApiServices } from "../../services/api_services";
import { CallService } from "../../services/call_service";
import { Cookies } from "../../utils/cookies";
import {
  CallServices,
  CoreServices,
  ReportServices,
  emailOtpVerification,
  resendOtp,
  updatePassword,
  emailotpverification,
} from "../../base/service/apiServices";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { LoginActions } from "../../store/slices/authentication_slice/login_slice";
import { LoginService } from "../../base/service/loginService";
import { UserSettingsActions } from "../../store/slices/settings_slice/user_settings_slice";
import axios from "axios";
import callChatService from "../../base/service/chatService";
// import { getAllContactList } from "../../store/api/helperspi/contactListapiService";
import { getAllUsers } from "../../store/api/user_management";
import jwt_decode from "jwt-decode";
import { loginConfig } from "./LoginConstant";
import styles from "./loginnew.module.scss";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import presenceService from "../../base/service/presence";
import store from "../../store/redux-store/root_store";
import Loading from '../../components/loader/loader'
import { outboundCampaignSliceAction } from "../../store/slices/outboundCampaign/outboundCampaignslice";
import { notification } from "antd";
import Google from '../../styles/images/googlelogin.svg';
import Microsoft from '../../styles/images/microsoft.svg';
import Apple from '../../styles/images/apple.svg';
import Worktual from '../../styles/images/logomain.svg';
import Messageicon from "../../styles/images/emailin.svg";
import Lockicon from "../../styles/images/lock.svg";
import {
  LoginSocialApple,
  LoginSocialGoogle,
  LoginSocialMicrosoft,
} from "reactjs-social-login";
import jwtDecode from "jwt-decode";
import OTPInput from "./otpinput";

type loginState = {
  email: string;
  password: string;
  remember: boolean;
  togglePass: boolean;
  errors: boolean;
  showPass: boolean;
  LoggedIn: boolean;
  errorMessage: {
    emailError: string;
    passWordError: string;
    validationError: String;
  };
  isForgetPassword: string;
  isChattour: number;
};

const Login = () => {
  // let cookieData: any = Cookie.get();
  const dispatch = useDispatcher();
  const loginSlice = useSelector((state: any) => state.loginUser);
  const { isGetAllcontacts, allContactList } = useSelector((state: any) => state.contactListForAgent)
  const [showLogin, setShowLogin] = useState(false);
  const [loader, setLoader] = useState<any>(false);
  const accessToken = GetItemFromStorage(LocalStorage?.ACCESS_TOKEN);

  const shopifyCred = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
  const bigCommerceCred: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_CRED);
  const bigCommerceSource: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_SOURCE);
  const wixCred: any = sessionStorage.getItem(LocalStorage.WIX_CRED);

  const [getConnectorTempEcomData, setConnectorTempEcomData] = useState<any>({
    shopifyCred: shopifyCred ? shopifyCred : null,
    wixCred: wixCred ? wixCred : null
  });


  const updateFlow = async () => {
    CoreServices.get(`/did_purchase_list`).then(async (value: any) => {
      if (value && value.data.statusCode === 200) {
        let contactPurchaseList = value.data.getDidNumberlist.list;
        for (let api of contactPurchaseList) {
          if (api.defaultUpdated === 0 && api.callFlowId == "9876543210") {
            CoreServices.put({ recording: api.recording, callFlowId: api.callFlowId }, `/did_purchase_update/${api.your_number}`)
              .then((response: any) => {
                console.log("updated:", response);
              });
          }
        }
      }
    });
  };

  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

  const [login, setLogin] = useState<loginState>({
    email: "",
    password: "",
    remember: false,
    showPass: false,
    togglePass: false,
    LoggedIn: false,
    errors: false,
    errorMessage: {
      emailError: "",
      passWordError: "",
      validationError: "",
    },
    isForgetPassword: "login",
    isChattour: 0,
  });

  useEffect(() => {
    if (!(loginSlice.loginError.isLoginError && loginSlice.loginError.errorMsg)) return;

    notification.error({
      message: loginSlice.loginError.errorMsg,
      placement: 'top',
      duration: 10,
      style: {
        whiteSpace: 'nowrap',
        width: 'auto',
        maxWidth: '90vw',
      }
    });

    const timer = setTimeout(() => {
      dispatch(LoginActions.clearLoginError());
    }, 10000);

    return () => clearTimeout(timer);
  }, [loginSlice.loginError.isLoginError, loginSlice.loginError.errorMsg]);

  useEffect(() => {
    if (login.LoggedIn === true) {
      SignIn();
    }
  }, [login.LoggedIn]);

  useEffect(() => {
    const init = async () => {
      let tokenData: any = Cookies.get();
      let Authorization: any = tokenData['ssoToken'] ?? "";
      // const shopifyCred = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
      // const bigCommerceCred: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_CRED);
      // const bigCommerceSource: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_SOURCE);
      // const wixCred: any = sessionStorage.getItem(LocalStorage.WIX_CRED);
      if (Authorization !== "") {
        // ClearStorage();
        sessionStorage.clear();
        const auth: any = jwt_decode(Authorization);
        if (auth?.is_cas_user === 1) {
          try {
            import('../../components/webChatScreen');
            // let isValidPlan: boolean = true;
            setLoader(true);
            setShowLogin(false);
            SetItemInStorage(LocalStorage.IS_LOGIN_INIT_FUNC, true);
            SetItemInStorage(LocalStorage.ACCESS_TOKEN, Authorization);
            SetItemInStorage(LocalStorage.WSS_URL, config().CALL_SERVER_WSS_URL);
            SetItemInStorage(LocalStorage.VIDEO_WSS_URL, config().VIDEO_CALL_SERVER_WSS_URL);
            SetItemInStorage(LocalStorage.REFRESH_TOKEN, Authorization);
            new callChatService(Authorization, navigate, dispatch);
            let LoginUserDetails: any = jwt_decode(Authorization);

            const checkSuspended = await handleAccountsuspended(Authorization, LoginUserDetails, dispatch)
            if(checkSuspended){
              // if(LoginUserDetails?.roleId == 3){
              //   navigate(`/accountsuspended?token=${value.data.token}`)
              //   new aiMyPlanSocketService(LoginUserDetails, navigate, dispatch);
              //   Cookies.clear();
              //   ClearStorage();
              //   sessionStorage.clear();
              //   return true
              // }

              setLoading(false);
              setLogin((login :any)=> ({
                ...login,
                errorMessage: {
                  ...login.errorMessage,
                  validationError: loginConfig().ACCOUNT_SUSPENDED,
                },
              }));
              setErrors({ wholeError: true });
              Cookies.clear();
              ClearStorage();
              sessionStorage.clear();
              return true
            }

            const loginTime: number = Date.now();
            SetItemInStorage(LocalStorage.LOGIN_TIME, loginTime);
            const isAnotherUserLoggedIn: any = await new Promise((resolve) => {
              const timeout = setTimeout(() => resolve({ status: '500', message: "Server did not respond" }), 5000);
              callChatService?.io?.emit('multi_login_restriction',
                {
                  email: LoginUserDetails?.Email,
                  ext: LoginUserDetails?.ext,
                  domainId: LoginUserDetails?.domain_id,
                  loginTime: loginTime,
                  source: 'CCAAS:BROWSER',
                },
                (response: any) => {
                  clearTimeout(timeout);
                  resolve(response);
                }
              );
            }).catch((error: any) => console.log('isAnotherUserLoggedIn errrrrrrr', error));
            const allowMultipleUser = tokenData['allowMultipleLogin'];
            if (isAnotherUserLoggedIn?.status === '200' || allowMultipleUser) {
              Cookies.set('allowMultipleLogin', true, 1);
              callChatService.io.emit('update_inactivity_presence', false);
              new presenceService(Authorization, navigate, dispatch, 0);
              let uuidNew: any = uuidv4();
              if (!GetItemFromStorage("deviceid")) {
                SetItemInStorage("deviceid", uuidNew);
              } else {
                uuidNew = GetItemFromStorage("deviceid");
              }
              SetItemInStorage(LocalStorage.ROLE_ID, LoginUserDetails?.ccas_role_info);
              SetItemInStorage(LocalStorage.PRODUCT_ID, LoginUserDetails.product_id);
              SetItemInStorage(LocalStorage.PLAN_ID, LoginUserDetails.parent_id);
              LoginUserDetails.roleId = LoginUserDetails?.ccas_role_info;
              const userObject = {
                username: LoginUserDetails.Email,
                password: "",
                source: "CCAAS:BROWSER",
                ipAddress: "136.144.56.255:443",
                isForceLogin: false,
                deviceId: uuidNew,
              };

              let data = {
                "company_id": LoginUserDetails.companyId
              }
              try {
                await CoreServices.get(`/get_user_details_email`)
                  .then((response: any) => {
                    if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
                      var chatflag: any = response.data.getUserDetailsRes[0].chatFlag === null ? 0 : response.data.getUserDetailsRes[0].chatFlag;
                      LoginUserDetails["isChattour"] = chatflag;
                      SetItemInStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS, response.data.getUserDetailsRes[0]);
                      dispatch(outboundCampaignSliceAction.setUserCallInfo(response?.data?.getUserDetailsRes?.[0]?.outboundCampaignCall ?? 0))
                    } else {
                      // Cookies.clear();
                      clearData(loginConfig().NO_ACCOUNT_FOUND);
                      return;
                    }
                  })
                  .catch((error) => {
                    console.log("get_user_details_email>>>", error);
                  });
              } catch (error) {
                console.log("get_user_details_email error>>>>", error)
              }
              let chatTour: any = LoginUserDetails?.isChattour === 0 && (LoginUserDetails?.kevin_plan?.plan_id === 33 || LoginUserDetails?.kevin_plan?.plan_id === 55 || LoginUserDetails?.kevin_plan?.plan_id === 56 || LoginUserDetails?.kevin_plan?.plan_id === 96 || LoginUserDetails?.kevin_plan?.plan_id === 97 || LoginUserDetails?.kevin_plan?.plan_id === 103 || LoginUserDetails?.kevin_plan?.plan_id === 107 || LoginUserDetails?.kevin_plan?.plan_id === 120 || LoginUserDetails?.kevin_plan?.plan_id === 121 || LoginUserDetails?.kevin_plan?.plan_id === 122 || LoginUserDetails?.kevin_plan?.plan_id === 123 || LoginUserDetails?.kevin_plan?.plan_id === 124 || LoginUserDetails?.kevin_plan?.plan_id === 77 || LoginUserDetails?.kevin_plan?.plan_id === 78 || LoginUserDetails?.kevin_plan?.plan_id === 127 || LoginUserDetails?.kevin_plan?.plan_id === 128 || LoginUserDetails?.kevin_plan?.plan_id === 133 || LoginUserDetails?.kevin_plan?.plan_id === 131 || LoginUserDetails?.kevin_plan?.plan_id === 130) ? true : false

              if (chatTour && LoginUserDetails.roleId === ROLES.ADMIN_ROLE_ID) {
                navigate("/chatbotonboarding");
              } else {
                if (LoginUserDetails?.roleId === ROLES.ADMIN_ROLE_ID || LoginUserDetails.roleId === ROLES.OWNER_ROLE_ID || LoginUserDetails.roleId === ROLES.SUB_OWNER_ROLE_ID) {
                  if (getConnectorTempEcomData.shopifyCred) { navigate('/shopifystorecheck') }
                  else if (getConnectorTempEcomData.wixCred) {
                    navigate('/wixstorecheck');
                  }
                  else {
                    // LoginUserDetails?.product_id === "15" ? navigate("/standaloneDashboard") : navigate("/dashboard");
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                  }
                } else if (LoginUserDetails.roleId === ROLES.SUPERVISOR_ROLE_ID) {
                  // LoginUserDetails?.product_id === "15" ? navigate("/standaloneDashboard") : navigate("/dashboard");
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                } else {
                  // LoginUserDetails?.product_id === "15" ? navigate("/agentdashboardstandalone") : navigate("/agentdashboard")
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                }
              }
              await axios.post(`${config().MYACCOUNTSERVICE_URL}/billing/getBillServicePlan`, data).then((res: any) => {
                if (res?.data?.result.length > 0) {
                  dispatch(ChatActions.servicePlan(res?.data?.result[0]))
                  var Kevin_paln: any = res?.data?.result[0];
                  LoginUserDetails["kevin_plan"] = Kevin_paln;
                  if (parseInt(Kevin_paln?.product_id) !== 1 && parseInt(Kevin_paln?.product_id) !== 15 && parseInt(Kevin_paln?.product_id) !== 17) { // ccass=1 and bot=15
                    clearData(loginConfig().COMMON_ERROR)
                    return;
                    // } else if (res?.data?.result[0]?.freetrail_rem_days < 0 && window.location.host.includes('worktual')) {
                    //   isValidPlan = false;
                    //   return;
                  }
                }
              }).catch((error: any) => { console.log(error, "error") });
              // if (!isValidPlan) {
              //   clearData('Your plan has expired. Please contact us for more information');
              //   setShowLogin(true);
              //   return;
              // }
              await updateFlow();
              SetItemInStorage(LocalStorage.USER_EMAIL, userObject?.username.trim());
              SetItemInStorage(LocalStorage.USER_DETAILS, LoginUserDetails);
              // SetItemInStorage(LocalStorage.LOGIN_TIME, Date.now());
              setLoading(false);
              SetItemInStorage(LocalStorage.REMEMBER_ME, login.remember);
              CoreServices.get(`/get_user_details/${userObject?.username}`)
                .then((result: any) => {
                  if (result?.data.statusCode === 200) {
                    SetItemInStorage(LocalStorage.AGENT_EXT, result?.data?.agentExt);
                  }
                })
                .catch((error) => { });
              SetItemInStorage("isUpdate", "0");
              createCallConnection();
              // !isGetAllcontacts && allContactList && dispatch(getAllContactList());
              dispatch(getAllUsers());
              let updatedata = {
                isVoice: 0,
                isVoiceCallTransfer: 0,
                isChat: 0,
                isChatTransfer: 0,
                isEmail: 0,
                isEmailTransfer: 0,
                stateTime: Math.floor(Date.now() / 1000),
                statusName: "Not Ready",
              };
              SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
              SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);
              axios.put(`${config().BASE_URL}/core_service/v1/update_agent_status_value/${login.email}`, updatedata, {
                headers: {
                  appId: config().APPID,
                  appSecret: config().AppSECRET,
                  Authorization: Authorization,
                },
              })
                .then((value: any) => {
                  if (value && value.data.statusCode === 200) {
                    SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
                    SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);
                  }
                });
              sessionStorage.setItem("logindetails", JSON.stringify(LoginUserDetails));

              dispatch(UserSettingsActions.updateMenuValue({ settingsMenuValue: "cc" }));

              const uuid = uuidv4();
              const date = new Date();
              let timeStamp: any = date.getTime();
              SetItemInStorage("uuid", uuid);
              SetItemInStorage("getRandomColor3", getRandomColor3());
              const body = {
                logInSessionId: uuid,
                logInTimestamp: timeStamp,
              };
              const { agentStatus } = store.getState().agentState;
              const { users } = store.getState().userList;
              let status: any = null
              if (agentStatus?.length > 0) {
                [status] = agentStatus.filter((i: any) => { return "Not Ready" === i?.statusName?.trim() })
              }
              let enableStatus: any = null
              if (users.length > 0) {
                [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
              }
              presenceService?.io?.emit("updatestate_backend", {
                domainId: LoginUserDetails?.domainId,
                isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
                isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
                isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
                isChatTransfer: status?.isChatTransfer ?? 0,
                isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
                isEmailTransfer: status?.isEmailTransfer ?? 0,
                stateTime: Math.floor(Date.now() / 1000),
                statusName: "Not Ready",
                ext: LoginUserDetails?.ext,
                email: LoginUserDetails?.Email,
                agentStatus: 0,
                userId: LoginCcaasUserDetails?.UserID,
                routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
                roleId: LoginCcaasUserDetails?.roleid,
                skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
                routingMethod: enableStatus?.routingMethod ?? 0
              });
              sessionStorage.setItem('presence', "Not Ready")

              dispatch(AgentStateAction.setCurrentStatus({ status: "Not Ready" }));

              CoreServices.post(body, "/insert_login_session_history").catch((e: any) => console.error(e));
            } else {
              clearData(isAnotherUserLoggedIn?.message);
              setShowLogin(true);
            }

          } catch (error) {
            console.log(error)
          } finally {
            setLoader(false)
          }
        } else {
          clearData('');
          setShowLogin(true);
          // navigate("/login", { replace: true });
        }

      } else {
        clearData('');
        setShowLogin(true);
      }
      dispatch(ChatActions.reset());
    };

    init();
  }, [])
  const clearData = (error: any) => {
    let shopifyStore = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
    let bigcommerceCred = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_CRED);
    let bigcomerceSource = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_SOURCE);
    let wixStore = sessionStorage.getItem(LocalStorage.WIX_CRED);
    Cookies.clear();
    ClearStorage();
    localStorage.clear();
    sessionStorage.clear();
    setLoading(false);
    setLogin({
      ...login,
      errorMessage: {
        ...login.errorMessage,
        validationError: error,
      },
    });
    callChatService.destroy();
    setErrors({ wholeError: true });
    if (shopifyStore || bigcommerceCred || bigcomerceSource || wixStore) {

      if (shopifyStore !== null) {
        sessionStorage.setItem(LocalStorage.SHOPIFY_CRED, shopifyStore);
      }
      if (bigcommerceCred && bigcomerceSource) {
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_CRED, bigcommerceCred);
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_SOURCE, bigcomerceSource);
      }
      if (wixStore) {
        sessionStorage.setItem(LocalStorage.WIX_CRED, wixStore);
      }
    }

  }
  const getRandomColor3 = () => {
    let random: number = Math.floor(Math.random() * 10) + 1;
    let className: string = random < 10 ? `profileview color${random}` : "profileview color10";
    return className;
  };

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setErrors] = useState<any>({
    email: false,
    password: false,
    wholeError: false,
  });

  const navigate = useNavigate();
  const { createCallConnection } = CallService(dispatch, navigate);

  const location = useLocation();

  const togglePassword = () => {
    setLogin({ ...login, togglePass: !login.togglePass });
  };

  const ringer = () => {
    const audio = document.getElementById("ringer") as HTMLAudioElement;
    // audio.src = process.env.PUBLIC_URL + "/ringtone/ringback.wav";
    audio.src = process.env.PUBLIC_URL + "/ringtone/ringback--linux.mp3";

    audio.load(); // This re-evaluates the <source> children
  };
  // con''st token: any = Cookie.get();
  const SignIn = async () => {
    console.log("loginObect", login)
    // const shopifyCred = GetItemFromStorage(LocalStorage.SHOPIFY_CRED)
    dispatch(AgentStateAction.setCurrentStatus({ status: "Not Ready" }));
    // const shopifyCred: any = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
    // const bigCommerceCred: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_CRED);
    // const bigCommerceSource: any = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_SOURCE);
    // const wixCred: any = sessionStorage.getItem(LocalStorage.WIX_CRED);
    Cookies.clear();
    ClearStorage();
    // navigate("/login");
    localStorage.clear();
    sessionStorage.clear();
    if (getConnectorTempEcomData.shopifyCred !== null && getConnectorTempEcomData.shopifyCred !== '') {
      sessionStorage.setItem(LocalStorage.SHOPIFY_CRED, getConnectorTempEcomData.shopifyCred);
    }

    if (getConnectorTempEcomData.wixCred) {
      sessionStorage.setItem(LocalStorage.WIX_CRED, getConnectorTempEcomData.wixCred);
    }

    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const emailRegx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (login.password === "" && login.email === "") {
      setErrors({ ...error, wholeError: true });
      setLogin({
        ...login,
        errorMessage: {
          ...login.errorMessage,
          validationError: loginConfig().BLANK_VALIDATION,
        },
      });
    } else if (login.email === "") {
      setErrors({ ...error, email: true });
      setLogin({
        ...login,
        errorMessage: {
          ...login.errorMessage,
          emailError: loginConfig().EMAIL_BLANK,
        },
      });
    }
    // else if (!emailRegx.test(login.email)) {
    //   setErrors({ ...error, email: true });
    //   setLogin({
    //     ...login,
    //     errorMessage: {
    //       ...login.errorMessage,
    //       emailError: loginConfig().INVLID_EMAIL,
    //     },
    //   });
    // }
    else if (login.password === "") {
      setErrors({ ...error, password: true });
      setLogin({
        ...login,
        errorMessage: {
          ...login.errorMessage,
          passWordError: loginConfig().BLANK_PASSWORD,
        },
      });
    } else {
      setErrors({ wholeError: false });
      // let isValidPlan: boolean = true;
      let userObject = {};
      let uuidNew: any = uuidv4();
      if (!GetItemFromStorage("deviceid")) {
        SetItemInStorage("deviceid", uuidNew);
      } else {
        uuidNew = GetItemFromStorage("deviceid");
      }
      setLoading(true);
      if (!login.LoggedIn) {
        userObject = {
          username: login.email.trim(),
          password: login.password.trim(),
          source: "Web",
          ipAddress: "136.144.56.255:443",
          //  isForceLogin: true,
          deviceId: uuidNew,
          loginCheck: getDynamicLocation(),
          location: countryName
        };
      } else {
        userObject = {
          username: login.email.trim(),
          password: login.password.trim(),
          source: "Web",
          ipAddress: "136.144.56.255:443",
          isForceLogin: true,
          deviceId: uuidNew,
          loginCheck: getDynamicLocation(),
          location: countryName
        };
      }

      let LoginUserDetails: any = {};
      try {
        await LoginService.login(userObject).then(async (value: any) => {
          if (value && value?.data?.statusCode === 200 && value?.data?.is_cas_user === 1) {
            SetItemInStorage(LocalStorage.IS_LOGIN_INIT_FUNC, true);
            SetItemInStorage(LocalStorage.ACCESS_TOKEN, value.data.token);
            SetItemInStorage(LocalStorage.WSS_URL, config().CALL_SERVER_WSS_URL);
            SetItemInStorage(LocalStorage.REFRESH_TOKEN, value.data.refresh_token);
            let tokenData: any = Cookies.get();
            if (!tokenData['ssoToken']) {
              Cookies.set("ssoToken", value.data.token, 1);
            }
            import('../../components/webChatScreen')
            new callChatService(value.data.token, navigate, dispatch);
            LoginUserDetails = jwt_decode(value.data.token);

            const checkSuspended = await handleAccountsuspended(value.data.token, LoginUserDetails, dispatch)
            if (checkSuspended) {
              setLoading(false);
              setLogin((login: any) => ({
                ...login,
                errorMessage: {
                  ...login.errorMessage,
                  validationError: loginConfig().ACCOUNT_SUSPENDED,
                },
              }));
              setErrors({ wholeError: true });
              Cookies.clear();
              ClearStorage();
              localStorage.clear();
              sessionStorage.clear();
              return;
            }

            const loginTime: number = Date.now();
            SetItemInStorage(LocalStorage.LOGIN_TIME, loginTime);
            const isAnotherUserLoggedIn: any = await new Promise((resolve) => {
              const timeout = setTimeout(() => resolve({ status: '500', message: "Server did not respond" }), 5000);
              callChatService?.io?.emit('multi_login_restriction',
                {
                  email: LoginUserDetails?.Email,
                  ext: LoginUserDetails?.ext,
                  domainId: LoginUserDetails?.domain_id,
                  loginTime: loginTime,
                  source: 'CCAAS:BROWSER',
                },
                (response: any) => {
                  clearTimeout(timeout);
                  resolve(response);
                }
              );
            }).catch((error: any) => console.log('isAnotherUserLoggedIn errrrrrrr', error));
            // SetItemInStorage(LocalStorage.PRODUCT_ID, "15");
            if (isAnotherUserLoggedIn?.status === '200') {
              Cookies.set('allowMultipleLogin', true, 1);
              let tbUser_flag = false;
              try {
                await CoreServices.get(`/get_user_details_email`)
                  .then((response: any) => {
                    if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
                      var chatflag: any = response.data.getUserDetailsRes[0].chatFlag === null ? 0 : response.data.getUserDetailsRes[0].chatFlag;
                      LoginUserDetails["isChattour"] = chatflag;
                      SetItemInStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS, response.data.getUserDetailsRes[0]);
                      dispatch(outboundCampaignSliceAction.setUserCallInfo(response?.data?.getUserDetailsRes?.[0]?.outboundCampaignCall ?? 0))
                      // Cookie.set("LoginUserCcaasDetails", JSON.stringify(response.data.getUserDetailsRes[0]), 1);
                    } else {
                      tbUser_flag = true;
                      Cookies.clear();
                      // window.location.href = "/login";
                      return;
                    }
                  })
                  .catch((error) => {
                    console.log("get_user_details_email error>>>>", error)
                  });
              } catch (error) {
                console.log("get_user_details_email error>>>>", error)
              }
              new presenceService(value.data.token, navigate, dispatch, 3);
              setLogin({ ...login, LoggedIn: false });
              const userObject = {
                username: login.email.trim(),
                password: login.password.trim(),
                source: "CCAAS:BROWSER",
                ipAddress: "136.144.56.255:443",
                isForceLogin: false,
                deviceId: uuidNew,
              };
              let data = {
                "company_id": LoginUserDetails.companyId
              }
              let product_flag = true;
              await axios.post(`${config().MYACCOUNTSERVICE_URL}/billing/getBillServicePlan`, data).then((res: any) => {
                if (res?.data?.result.length > 0) {
                  dispatch(ChatActions.servicePlan(res?.data?.result[0]))
                  var Kevin_paln: any = res?.data?.result[0];
                  LoginUserDetails["kevin_plan"] = Kevin_paln;
                  if (parseInt(Kevin_paln?.product_id) !== 1 && parseInt(Kevin_paln?.product_id) !== 15 && parseInt(Kevin_paln?.product_id) !== 17) { // ccass=1 and bot=15
                    product_flag = false;
                    return;
                    // } else if (res?.data?.result[0]?.freetrail_rem_days < 0 && window.location.host.includes('worktual')) {
                    //   isValidPlan = false;
                    //   return;
                  }
                  SetItemInStorage(LocalStorage.PRODUCT_ID, Kevin_paln.product_id);
                  SetItemInStorage(LocalStorage.PLAN_ID, Kevin_paln.parent_id);
                }
              }).catch((error: any) => { console.log(error, "error") });
              // if (!isValidPlan) {
              //   clearData('Your plan has expired. Please contact us for more information');
              //   setShowLogin(true);
              //   return;
              // }

              if (!product_flag) {
                Cookies.clear();
                ClearStorage();
                localStorage.clear();
                sessionStorage.clear();

                setLoading(false);
                setLogin({
                  ...login,
                  errorMessage: {
                    ...login.errorMessage,
                    validationError: loginConfig().COMMON_ERROR,
                  },
                });
                setErrors({ wholeError: true });
                // window.location.href = "/login";
                return; // product_id verification  product id
              }
              if (tbUser_flag) {
                Cookies.clear();
                ClearStorage();
                localStorage.clear();
                sessionStorage.clear();
                setLoading(false);
                setLogin({
                  ...login,
                  errorMessage: {
                    ...login.errorMessage,
                    validationError: loginConfig().NO_ACCOUNT_FOUND,
                  },
                });
                setErrors({ wholeError: true });
                // window.location.href = "/login";
                return; // product_id verification  product id
              }

              await ApiServices.post(config().CORESERVICE_URL, "/get_ccaas_role_info", userObject).then((resp: any) => {
                if (resp?.data?.statusCode === 200) {
                  const ccaas_role_id: any = resp?.data?.getCCaasRoleIdInfoRes[0].ccas_role_info;
                  LoginUserDetails["ccas_role_info"] = ccaas_role_id;
                  SetItemInStorage(LocalStorage.ROLE_ID, ccaas_role_id);
                  // Cookie.set("roleId", ccaas_role_id, 1);
                  LoginUserDetails.roleId = ccaas_role_id;
                }
              });
              await updateFlow();
              SetItemInStorage(LocalStorage.USER_EMAIL, userObject?.username.trim());
              SetItemInStorage(LocalStorage.USER_DETAILS, LoginUserDetails);
              // const loginTime: number = Date.now();
              // SetItemInStorage(LocalStorage.LOGIN_TIME, loginTime);

              // Cookie.set("userEmail", userObject?.username.trim(), 1);
              // Cookie.set("userDetials", JSON.stringify(LoginUserDetails), 365);

              // Changed the normal redux implementation to redux toolkit

              dispatch(
                LoginActions.login({
                  token: value.data.token,
                  loginUserDetails: LoginUserDetails,
                })
              );

              // setLoading(false);
              SetItemInStorage(LocalStorage.REMEMBER_ME, login.remember);
              // Cookie.set("RememberMe", login.remember, 30);
              await CoreServices.get(`/get_user_details/${userObject?.username}`)
                .then((result: any) => {
                  if (result?.data.statusCode === 200) {
                    SetItemInStorage(LocalStorage.AGENT_EXT, result?.data?.agentExt);
                    // Cookie.set("agentExt", result?.data?.agentExt, 1);
                  }
                })
                .catch((error) => { });

              if (login.remember === true) {
                SetItemInStorage(LocalStorage.USER_EMAIL, login.email);
                SetItemInStorage(LocalStorage.PASSWORD, encryptCodes(login.password, "PassWord"));

                // Cookie.set("Email", login.email, 1);
                // Cookie.set("passWord", encryptCodes(login.password, "PassWord"), 1);
              }
              SetItemInStorage("isUpdate", "0");
              createCallConnection();
              // !isGetAllcontacts && allContactList && dispatch(getAllContactList());
              dispatch(getAllUsers());
              // await CoreServices.get(`/get_user_details_email`)
              //   .then((response: any) => {
              //     if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
              //       SetItemInStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS, response.data.getUserDetailsRes[0]);
              //       // Cookie.set("LoginUserCcaasDetails", JSON.stringify(response.data.getUserDetailsRes[0]), 1);
              //     }
              //     else {
              //       navigate("/login")
              //     }
              //   })
              //   .catch((error) => { });
              let updatedata = {
                isVoice: 0,
                isVoiceCallTransfer: 0,
                isChat: 0,
                isChatTransfer: 0,
                isEmail: 0,
                isEmailTransfer: 0,
                stateTime: Math.floor(Date.now() / 1000),
                statusName: "Not Ready",
              };
              let statusColor = "#d62f49";
              SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
              // SetItemInStorage(LocalStorage.WORK_STATUS_COLOR, statusColor);
              SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);
              axios
                .put(`${config().BASE_URL}/core_service/v1/update_agent_status_value/${login.email.trim()}`, updatedata, {
                  headers: {
                    appId: config().APPID,
                    appSecret: config().AppSECRET,
                    Authorization: value.data.token,
                  },
                })
                .then((value: any) => {
                  if (value && value.data.statusCode === 200) {
                    SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
                    // SetItemInStorage(LocalStorage.WORK_STATUS_COLOR, statusColor);
                    SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);

                    // Cookie.set("workStatus", updatedata.statusName, 1);
                    // Cookie.set("workStatusColor", statusColor, 1);
                    // Cookie.set("stateChange", updatedata.stateTime, 1);
                  }
                });
              sessionStorage.setItem("logindetails", JSON.stringify(LoginUserDetails));

              dispatch(UserSettingsActions.updateMenuValue({ settingsMenuValue: "cc" }));

              const uuid = uuidv4();
              const date = new Date();
              let timeStamp: any = date.getTime();
              SetItemInStorage("uuid", uuid);
              SetItemInStorage("getRandomColor3", getRandomColor3());
              const body = {
                logInSessionId: uuid,
                logInTimestamp: timeStamp,
              };
              // dispatch(AgentStateAction.setCurrentStatus({ status: "Not Ready" }));
              const { agentStatus } = store.getState().agentState;
              const { users } = store.getState().userList;
              let status: any = null
              if (agentStatus?.length > 0) {
                [status] = agentStatus.filter((i: any) => { return "Not Ready" === i?.statusName?.trim() })
              }
              let enableStatus: any = null
              if (users.length > 0) {
                [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
              }
              console.log('presenceService 5', status, enableStatus);
              presenceService?.io?.emit("updatestate_backend", {
                domainId: LoginUserDetails?.domainId,
                isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
                isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
                isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
                isChatTransfer: status?.isChatTransfer ?? 0,
                isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
                isEmailTransfer: status?.isEmailTransfer ?? 0,
                stateTime: Math.floor(Date.now() / 1000),
                statusName: "Not Ready",
                ext: LoginUserDetails?.ext,
                email: LoginUserDetails?.Email,
                agentStatus: 0,
                userId: LoginCcaasUserDetails?.UserID,
                routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
                roleId: LoginCcaasUserDetails?.roleid,
                skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
                routingMethod: enableStatus?.routingMethod ?? 0,
                inboundCall: enableStatus?.inboundCall,
                outboundCampaignCall: enableStatus?.outboundCampaignCall,
                is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
              });
              sessionStorage.setItem('presence', "Not Ready")
              ringer()
              await CoreServices.post(body, "/insert_login_session_history").catch((e: any) => console.error(e));
              let chatTour: any = LoginUserDetails?.isChattour === 0 && (LoginUserDetails?.kevin_plan?.plan_id === 33 || LoginUserDetails?.kevin_plan?.plan_id === 55 || LoginUserDetails?.kevin_plan?.plan_id === 56 || LoginUserDetails?.kevin_plan?.plan_id === 96 || LoginUserDetails?.kevin_plan?.plan_id === 97 || LoginUserDetails?.kevin_plan?.plan_id === 103 || LoginUserDetails?.kevin_plan?.plan_id === 107 || LoginUserDetails?.kevin_plan?.plan_id === 120 || LoginUserDetails?.kevin_plan?.plan_id === 121 || LoginUserDetails?.kevin_plan?.plan_id === 122 || LoginUserDetails?.kevin_plan?.plan_id === 123 || LoginUserDetails?.kevin_plan?.plan_id === 124 || LoginUserDetails?.kevin_plan?.plan_id === 77 || LoginUserDetails?.kevin_plan?.plan_id === 78 || LoginUserDetails?.kevin_plan?.plan_id === 93 || LoginUserDetails?.kevin_plan?.plan_id === 127 || LoginUserDetails?.kevin_plan?.plan_id === 128 || LoginUserDetails?.kevin_plan?.plan_id === 133 || LoginUserDetails?.kevin_plan?.plan_id === 131 || LoginUserDetails?.kevin_plan?.plan_id === 130) ? true : false

              console.log("LoginUserDetails >>>>>", LoginUserDetails?.kevin_plan?.plan_id);
              setLoading(false);
              if (chatTour && LoginUserDetails.roleId === ROLES.ADMIN_ROLE_ID) {
                navigate("/chatbotonboarding");
              } else {
                if (LoginUserDetails.roleId === ROLES.ADMIN_ROLE_ID || LoginUserDetails.roleId === ROLES.OWNER_ROLE_ID || LoginUserDetails.roleId === ROLES.SUB_OWNER_ROLE_ID) { //PRIVILLEGED_ROLES.includes(LoginUserDetails.roleId?.toString)) {
                  console.log("*******************");
                  if (getConnectorTempEcomData.shopifyCred !== null) {
                    console.log("inside if");
                    navigate("/shopifystorecheck");
                  }
                  else if (getConnectorTempEcomData.wixCred) {
                    navigate('/wixstorecheck');
                  }
                  else {
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                    
                    // LoginUserDetails.kevin_plan.product_id === "15"
                    //   ? navigate("/standaloneDashboard")
                    //   : navigate("/dashboard");
                  }
                } else if (LoginUserDetails.roleId === ROLES.SUPERVISOR_ROLE_ID) {
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                  // LoginUserDetails.kevin_plan.product_id === "15"
                  //   ? navigate("/standaloneDashboard")
                  //   : navigate("/dashboard");
                } else {
                    hassAccess("Dashboard/dynamicDash") 
                      ?  navigate("/dynamicdashboard") 
                      :  navigate("/dashboard")
                  // LoginUserDetails?.kevin_plan?.product_id === "15" || LoginUserDetails?.kevin_plan?.product_id === "17" ?
                  //   navigate("/agentdashboardstandalone") :
                  //   navigate("/agentdashboard")
                }
              }
            } else {
              clearData(isAnotherUserLoggedIn?.message);
              setShowLogin(true);
            }
          } else if (value && value?.data?.statusCode === 301) {
            if (value?.data.message) {
              setLoading(false);
              setLogin({
                ...login,
                errorMessage: {
                  ...login.errorMessage,
                  validationError: loginConfig().COMMON_ERROR,
                },
              });
              setErrors({ wholeError: true });
              Cookies.clear();
              ClearStorage();
              sessionStorage.clear();
              window.location.reload();
            }
          } else if (value && value?.data?.statusCode === 424) {
            setLogin({ ...login, LoggedIn: true });
          } else if (value) {
            setLoading(false);
            setLogin({
              ...login,
              errorMessage: {
                ...login.errorMessage,
                validationError: value?.data?.message || loginConfig().COMMON_ERROR,
              },
            });
            setErrors({ wholeError: true });
          } else {
            setLoading(false);
            setLogin({
              ...login,
              errorMessage: {
                ...login.errorMessage,
                validationError: value?.data?.message || loginConfig().AUTHENTICATION_FAILED,
              },
            });
            setErrors({ wholeError: true });
          }
        });
      } catch (e: any) {
        setLoading(false);
        setLogin({
          ...login,
          errorMessage: {
            ...login.errorMessage,
            validationError: e?.response?.data?.message ?? loginConfig().AUTHENTICATION_FAILED,
          },
        });
        setErrors({ wholeError: true });
      }
    } try {
      const agentStatus = await CoreServices.get("/get_agent_status");
      const aid = agentStatus?.data?.getAgentListRes?.find(
        (agent: { statusName: string }) => agent.statusName === "Not Ready"
      )?.aid;
      let body: any = {
        state: aid ?? 0,  // state: currentState?.statusName === 'Ready' ? 1 : currentState?.statusName === "Not Ready" ? 2 : currentState?.statusName === "Transfer Only" ? 3 : currentState?.statusName === "Away" ? 4 : currentState?.statusName === "Offline" ? 5 : currentState?.statusName === "Busy" ? 6 : null,
        timestamp: Date.now(),
      };
      await CallServices.post(body, `/create_state`);
    } catch (error) {
      console.log('error', error)
    }
    try {
      accessToken && await ReportServices.get("/get_dashboard_agent_status/0")
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    let getCookie: any = getToken();
    setLogin({ ...login, remember: login.remember });
    let isRemember: any = getCookie?.RememberMe && JSON.parse(getCookie.RememberMe);
    if (isRemember === true) {
      if (getCookie.passWord) {
        setLogin({
          ...login,
          email: getCookie.Email,
          password: decryptCodes(getCookie.passWord, "PassWord"),
          remember: isRemember,
        });
      }
    } else {
      setLogin({ ...login, email: "", password: "", remember: false });
    }
    const pathData = location?.pathname;
    if (pathData === "/login" || pathData === "/") {
      if (getCookie["accessToken"]) {
        let LoginUserDetails: any = jwt_decode(getCookie["accessToken"]);
        dispatch(LoginActions.updateLoadingState({ isLoadingBack: true }));

        // setTimeout(() => {
        //   dispatch(LoginActions.updateLoadingState({ isLoadingBack: true }));
        //   let isAdmin =
        //     getCookie["roleId"] && getCookie["roleId"].split(",").includes("1");
        //   if (isAdmin) {
        //     if (LoginUserDetails.initial_setup_flag === "0") {
        //       navigate("/choosechannelssteps");
        //     } else {
        //       navigate("/AllActivity");
        //     }
        //   } else if (
        //     !isAdmin &&
        //     getCookie["roleId"] &&
        //     getCookie["roleId"].split(",").includes("2")
        //   ) {
        //     navigate("/AllActivity");
        //   } else {
        //     navigate("/AgentDashBoard");
        //   }
        // }, 1000);
      }
    }
  }, []);

  const onChangeInput = (e: any) => {
    setLogin({ ...login, [e.target.name]: e.target.value, errors: false });
    setErrors({ ...error, email: false, password: false, wholeError: false });
  };
  const handleEnter = (e: any) => {
    if (e.keyCode === 13) {
      SignIn();
    }
  };
  const rememberMe = () => {
    setLogin({ ...login, remember: !login.remember });
  };

  const isSocialMedia = useRef(false);

  const socialMediaLogin = async (data: any, type: any) => {
    const _body = {
      email: data,
      device_type: "", // You can enhance this with UA-parser
      browser: "",     // Or use navigator.userAgent
      login_type: type
    };

    try {
      const response = await LoginService.socialMediaLogin(_body);
      if (response?.data?.results[0].v_errcode == 0) {
        let email = response?.data?.results[0]?.my_acc_email;
        let password = response?.data?.results[0]?.my_acc_password;
        isSocialMedia.current = true;
        const updatedLogin = {
          ...login,
          email,
          password,
          errors: false,
        };
        setLogin(updatedLogin);
        setErrors({ ...error, email: false, password: false, wholeError: false });
      } else if (response?.data?.results[0]?.v_errcode == -1) {
        setLoader(false);
        alert(response?.data?.results[0]?.v_errmsg);
      }
    } catch (err) {
      console.error("SocialMediaLogin error", err);
      return null;
    }
  };

  useEffect(() => {
    if (isSocialMedia.current) {
      SignIn();
      isSocialMedia.current = false;
    }
  }, [login.email, login.password]);
  const clearEmail = () => {
    setLogin({ ...login, email: "" });
  };

  const redirectToWorktual = () => {
    console.log("redirect ---------------");
    let shopifyCred = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
    if (shopifyCred) {
      window.open(`https://worktual.co.uk/chatbox/purchaseflow/freetrail_companydetails_shopfiy?shopify=${shopifyCred}`);
    }
    else {
      window.open('https://worktual.co.uk/pricing/#Ccaas');
    }
  };

  const [countryCode, setCountryCode] = useState('');
  const [countryName, setCountryName] = useState('');
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpMessage, setOtpMessage] = useState("");
  const [otpResendTimer, setOtpResendTimer] = useState(0);
  const [otpAttemptCount, setOtpAttemptCount] = useState(1);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const OTP_RESEND_COOLDOWN_SECONDS = 10 * 60;
  const OTP_MAX_ATTEMPTS = 5;

  useEffect(() => {
    const host = window.location.host;
    const parts = host.split('.');
    if (parts.length > 2) {
      const loc = parts[parts.length - 1]
      setCountryCode(loc);
      switch(loc){
        case 'in':
          setCountryName('India');
          break;
        case 'uk':
          setCountryName('United Kingdom');
          break;
        case 'com':
          setCountryName('United States');
          break;
      }
    } else {
      setCountryName('India');
    }
  }, []);

  useEffect(() => {
    if (login.isForgetPassword !== "otp" || otpResendTimer <= 0) return;

    const interval = window.setInterval(() => {
      setOtpResendTimer((prev) => {
        if (prev <= 1) {
          window.clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => window.clearInterval(interval);
  }, [login.isForgetPassword, otpResendTimer]);

  const resetForgotPasswordFlow = () => {
    setForgotError("");
    setForgotLoading(false);
    setOtp("");
    setOtpError("");
    setOtpLoading(false);
    setOtpMessage("");
    setOtpResendTimer(0);
    setOtpAttemptCount(1);
    setNewPassword("");
    setConfirmPassword("");
    setShowConfirmPassword(false);
    setPasswordError("");
    setPasswordLoading(false);
  };

  const backToLogin = (clearPassword = false) => {
    const preservedEmail = forgotEmail.trim();
    resetForgotPasswordFlow();
    setForgotEmail("");
    setLogin((prev) => ({
      ...prev,
      email: preservedEmail || prev.email,
      password: clearPassword ? "" : prev.password,
      isForgetPassword: "login",
    }));
  };

  const openForgotFlow = (prefillEmail?: string) => {
    resetForgotPasswordFlow();
    const nextEmail =
      prefillEmail !== undefined ? prefillEmail : forgotEmail || login.email || "";
    setForgotEmail(nextEmail);
    setLogin((prev) => ({ ...prev, isForgetPassword: "forget" }));
  };

  const handleForgotSubmit = async () => {
    const normalizedEmail = forgotEmail.trim();

    if (!normalizedEmail) {
      setForgotError("Email is required");
      return;
    }

    setForgotLoading(true);
    setForgotError("");
    try {
      const response: any = await emailotpverification({
        email: normalizedEmail,
        emailId: normalizedEmail,
      });

      if (response?.statusCode === 200) {
        setOtp("");
        setOtpAttemptCount(1);
        setOtpResendTimer(OTP_RESEND_COOLDOWN_SECONDS);
        setOtpMessage("");
        setLogin((prev) => ({ ...prev, isForgetPassword: "otp" }));
      } else {
        setForgotError(response?.message || "Invalid email address");
      }
    } catch (e: any) {
      setForgotError(
        e?.response?.data?.message || "Something went wrong. Please try again.",
      );
    } finally {
      setForgotLoading(false);
    }
  };

  const handleOTPChange = (value: string) => {
    setOtp(value);
    setOtpError("");
    setOtpMessage("");
  };

  const formatTimer = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const onVerifyOtp = async () => {
    if (otp.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }

    setOtpLoading(true);
    setOtpError("");
    try {
      const response: any = await emailOtpVerification({
        email: forgotEmail.trim(),
        verify_code: Number(otp),
      });

      if (response?.statusCode === 200) {
        setOtpMessage("");
        setLogin((prev) => ({ ...prev, isForgetPassword: "update" }));
      } else {
        setOtpError(response?.message || "OTP verification failed.");
      }
    } catch (e: any) {
      setOtpError(e?.response?.data?.message || "OTP verification failed.");
    } finally {
      setOtpLoading(false);
    }
  };

  const onResendOtp = async () => {
    if (otpResendTimer > 0) {
      setOtpError(
        `Please wait ${formatTimer(otpResendTimer)} before requesting a new OTP.`,
      );
      return;
    }

    if (otpAttemptCount >= OTP_MAX_ATTEMPTS) {
      setOtpError("Maximum OTP resend attempts reached.");
      return;
    }

    const normalizedEmail = forgotEmail.trim();
    if (!normalizedEmail) {
      setOtpError("Email is missing.");
      return;
    }

    setOtpLoading(true);
    setOtpError("");
    try {
      const response: any = await resendOtp({
        email: normalizedEmail,
        emailId: normalizedEmail,
      });

      if (response?.statusCode === 200) {
        setOtp("");
        setOtpMessage(response?.message || "OTP sent successfully.");
        setOtpAttemptCount((prev) => prev + 1);
        setOtpResendTimer(OTP_RESEND_COOLDOWN_SECONDS);
      } else {
        setOtpError(response?.message || "Unable to resend OTP.");
      }
    } catch (e: any) {
      setOtpError(e?.response?.data?.message || "Unable to resend OTP.");
    } finally {
      setOtpLoading(false);
    }
  };

  const onUpdatePassword = async () => {
    const pass = newPassword.trim();
    const confirm = confirmPassword.trim();
    const lowerPass = pass.toLowerCase();
    const email = forgotEmail.trim().toLowerCase();
    const emailName = email.split("@")[0] || "";
    const hasNoPersonalInfo =
      !lowerPass.includes(email) &&
      (!emailName || !lowerPass.includes(emailName));
    const hasMinLength = pass.length >= 8;
    const hasNumberOrSymbol = /[\d\W_]/.test(pass);

    if (!pass) {
      setPasswordError("New password is required.");
      return;
    }
    if (!hasNoPersonalInfo) {
      setPasswordError("Password cannot contain your name or e-mail.");
      return;
    }
    if (!hasMinLength) {
      setPasswordError("Password must be at least 8 characters.");
      return;
    }
    if (!hasNumberOrSymbol) {
      setPasswordError("Password must contain a number or symbol.");
      return;
    }
    if (pass !== confirm) {
      setPasswordError("Passwords do not match.");
      return;
    }

    setPasswordLoading(true);
    setPasswordError("");
    try {
      const response: any = await updatePassword({
        email: forgotEmail.trim(),
        new_pwd: pass,
      });

      if (response?.statusCode === 200) {
        backToLogin(true);
        navigate("/login");
      } else {
        setPasswordError(response?.message || "Password update failed.");
      }
    } catch (e: any) {
      setPasswordError(e?.response?.data?.message || "Password update failed.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const normalizedForgotEmail = forgotEmail.trim().toLowerCase();
  const forgotEmailName = normalizedForgotEmail.split("@")[0] || "";
  const trimmedNewPassword = newPassword.trim();
  const lowerNewPassword = trimmedNewPassword.toLowerCase();

  const isNoPersonalInfoRule =
    trimmedNewPassword.length > 0 &&
    !lowerNewPassword.includes(normalizedForgotEmail) &&
    (!forgotEmailName || !lowerNewPassword.includes(forgotEmailName));
  const isMinLengthRule = trimmedNewPassword.length >= 8;
  const isNumberOrSymbolRule = /[\d\W_]/.test(trimmedNewPassword);

  let passwordStrengthScore = 0;
  if (trimmedNewPassword.length > 0) passwordStrengthScore = 1;
  if (isMinLengthRule) passwordStrengthScore = 2;
  if (isMinLengthRule && isNumberOrSymbolRule) passwordStrengthScore = 3;
  if (isNoPersonalInfoRule && isMinLengthRule && isNumberOrSymbolRule) {
    passwordStrengthScore = 4;
  }

  const passwordStrengthClass =
    passwordStrengthScore === 4
      ? styles.stepverifystrong
      : passwordStrengthScore === 3
        ? styles.stepverifymoderate
        : passwordStrengthScore === 2
          ? styles.stepverifyfair
          : "";

  const passwordStrengthLabel =
    passwordStrengthScore >= 4
      ? "Strong"
      : passwordStrengthScore === 3
        ? "Moderate"
        : passwordStrengthScore === 2
          ? "Fair"
          : passwordStrengthScore === 1
            ? "Weak"
            : "";

  const passwordStrengthLabelClass =
    passwordStrengthScore >= 4
      ? styles.alertweakstrong
      : passwordStrengthScore === 3
        ? styles.alertweakmoder
        : passwordStrengthScore === 2
          ? styles.alertweakfair
          : styles.alertweak;

  return (
    <>
      {loader && <Loading />}
      {
        !loginSlice?.isLoadingBack && showLogin && (
          <>
            <div className={styles.loginheader}>
              <div className={styles.headerview}>
                <img src={Worktual} alt="Login" />
                {/* <img src={logo} alt="Login" /> */}
              </div>
              {/* <a className={styles.forgot} onClick={() => { window.open('https://worktual.co.uk/contact/') }}>Contact Us</a> */}
              <button className={`${styles.contactsign}`}>
                <a
                  className={`${styles.forgot} `}
                  onClick={() => {
                    switch (countryCode) {
                      case 'uk':
                        window.open('https://worktual.co.uk/contact/');
                        break;
                      case 'in':
                        window.open('https://worktual.in/contact/');
                        break;
                      case 'com':
                        window.open('https://worktual.com/contact/');
                        break;
                    }
                  }}
                >
                  Contact Us
                </a>
              </button>
            </div>
            {login.isForgetPassword === "login" && (
              // <Container fluid className={styles.mainloginscreen}>
              //   <Container>
              //     <Row className={styles.logincenter}>
              //       <Col sm={7} className={styles.logincenternew}>
              //         {" "}
              //         <img src={LoginImage} alt="Login" />
              //       </Col>
              //       <Col sm={5} className={styles.logincenternewright}>
              //         <div className={`${styles.innersections} ${styles.loginright}`}>

              //           <h4>Log in</h4>
              //           <div className={styles.loginborder}>

              //             <div className={styles.loginmain}>
              //               <label>Email ID / Employee ID</label>
              //               <input
              //                 type="input"
              //                 value={login.email}
              //                 maxLength={100}
              //                 className={`${styles.emailinput}`}
              //                 placeholder="Email id / Employee id"
              //                 name="email"
              //                 onChange={onChangeInput}
              //                 autoFocus={true}
              //               />
              //               {login.email !== "" && (
              //                 <span className={`icon_closefill  ${styles.showClear}`} onClick={clearEmail}>
              //                   {" "}
              //                 </span>
              //               )}
              //               {error.email && <span className={`${styles.errorText} ${styles.invaliderrorText}`}>{login.errorMessage.emailError}</span>}

              //             </div>

              //             <div className={styles.loginmain}>
              //               <label>Password</label>
              //               <input
              //                 className={`${styles.passwordbox}`}
              //                 value={login.password}
              //                 type={login.togglePass ? "input" : "password"}
              //                 placeholder="Password"
              //                 name="password"
              //                 onChange={onChangeInput}
              //                 onKeyDown={(e: any) => handleEnter(e)}
              //               />
              //               {login.password !== "" && (
              //                 <span
              //                   className={!login.togglePass ? `${"icon_Viewpassword"} ${styles.loginpass}` : `${"icon_Fillpassword"} ${styles.loginpass}`}
              //                   onClick={togglePassword}
              //                 ></span>
              //               )}

              //               {error.password && <span className={`${styles.errorText}  ${styles.invaliderrorText}`}> {login.errorMessage.passWordError}</span>}

              //             </div>

              //             <div className={styles.keepme}>
              //               <div className={styles.keepmecursor}>
              //                 <input className={styles.inputcheck} type="checkbox" placeholder="Remember" checked={login.remember} onChange={rememberMe} />
              // <label onClick={rememberMe}>Keep me logged in </label>
              //               </div>

              //               <div className={styles.forgot}>
              //                 <a onClick={() => window.open(`${process.env.REACT_APP_ENV === 'production' ? `https://myaccount.worktual.${domainExt}/forgotPassword` : `https://qa-myaccount.worktual.co.uk/forgotPassword`}`)}>Forgot Password?</a>
              //               </div>
              //             </div>
              //             {error.wholeError && <span className={styles.errorText}>{login.errorMessage.validationError}</span>}


              //             <div className={styles.loginmain}>
              //               {!loading ? <button onClick={SignIn} className={`${styles.btnSignin} ${loading ? "disabled" : ""}`}>
              //                 {/* <span>{!loading ? "Login" : <Lottie style={{ width: 50, margin: "0 auto" }} animationData={groovyWalkAnimation} />}</span> */}
              //                 Login
              //               </button>
              //                 :
              //                 <div className='loadersetactive'>
              //                   <Loading />
              //                 </div>
              //               }


              //               <p onClick={redirectToWorktual} className={styles.newworktual}>New to Worktual? <span>Signup</span></p>
              //             </div>
              //           </div>
              //         </div>
              //       </Col>
              //     </Row>
              //   </Container>
              // </Container>
              <div className={styles.body}>
                <div className={styles.centeredcontent}>
                  <div className={styles.lucasmain}>
                    {/* <div className={styles.worktualmain}> 
                                      <svg
                                width="112"
                                height="24"
                                viewBox="0 0 112 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M27.6223 4.37138V16.0318H19.6888V12.4299C19.6888 10.0173 17.7616 8.05952 15.3857 8.05952H11.8402V0H23.3192C25.6951 0 27.6223 1.95684 27.6223 4.37138Z"
                                  fill="#e6e4eb"
                                />
                                <path
                                  d="M19.6888 16.0312V23.9998L11.8439 16.0312H19.6888Z"
                                  fill="#e6e4eb"
                                />
                                <path
                                  d="M19.6888 12.429C19.6888 10.0154 17.7626 8.05859 15.3867 8.05859H11.8411L11.8439 8.06144H4V16.03H11.8439V8.06238L19.6879 16.0309V12.429H19.6888Z"
                                  fill="black"
                                />
                                <path
                                  d="M46.7524 4.97754L44.7749 12.2249L42.9457 5.24098H39.7564L37.9272 12.2249L35.9123 4.97754H32.6223L36.4477 18.8716H38.887L41.3506 11.718L43.7954 18.8716H46.2534L50.0788 4.97754H46.7524ZM53.3082 9.33375C50.6833 9.33375 48.5397 11.5114 48.5397 14.178C48.5397 16.8446 50.6833 19.0222 53.3082 19.0222C55.9331 19.0222 58.0767 16.8446 58.0767 14.178C58.0767 11.5114 55.9331 9.33375 53.3082 9.33375ZM53.3082 15.9804C52.3287 15.9804 51.534 15.173 51.534 14.178C51.534 13.183 52.3287 12.3756 53.3082 12.3756C54.2876 12.3756 55.0824 13.183 55.0824 14.178C55.0824 15.173 54.2876 15.9804 53.3082 15.9804ZM78.3987 6.49847H75.4044V14.9096C75.4044 17.651 76.7719 18.8706 79.1562 18.8706H80.9117V15.8287H79.2485C78.7308 15.8287 78.3987 15.4535 78.3987 14.9465V12.1302H81.0236V9.48253H78.3987V6.49752V6.49847ZM101.741 9.48348H99.2273V9.91559C98.5249 9.53939 97.7861 9.33281 96.9727 9.33281C94.3487 9.33281 92.2238 11.4915 92.2238 14.1581C92.2238 16.8247 94.3487 19.0213 96.9727 19.0213C97.8225 19.0213 98.5622 18.7768 99.2646 18.4195V18.8706H102.321V16.1206H101.741V9.48348ZM97.0455 15.9794C96.067 15.9794 95.2899 15.172 95.2899 14.1581C95.2899 13.1441 96.066 12.3548 97.0455 12.3548C98.0249 12.3548 98.8206 13.1621 98.8206 14.1581C98.8206 15.154 98.0258 15.9794 97.0455 15.9794ZM107.231 15.8287C106.787 15.8287 106.565 15.5284 106.565 15.0962V5.729H102.991V8.479H103.571V15.0593C103.571 17.7069 104.513 18.8706 107.138 18.8706H107.859V15.8287H107.23H107.231ZM61.2976 9.91464V9.48253H58.4265V12.2325H59.0067V18.8697H61.9637V13.4625C61.9637 12.8437 62.4636 12.3548 63.0728 12.3548H64.2919V9.48253H62.9618C62.3881 9.48253 61.834 9.57634 61.2976 9.91464ZM74.4763 9.48253H70.9279L68.4019 11.9795V5.729H64.8292V8.479H65.4085V18.8706H68.4028V16.186L68.9839 15.6136L71.3169 18.8706H74.939L70.9839 13.5763L74.4763 9.48348V9.48253ZM88.2305 14.8707C88.2305 15.4904 87.7314 15.9974 87.1214 15.9974C86.5113 15.9974 86.0132 15.4895 86.0132 14.8707V9.48253H82.4564V12.2325H83.0385V14.8707C83.0385 17.1611 84.8677 19.0203 87.1223 19.0203C89.3769 19.0203 91.207 17.1611 91.207 14.8707V9.48253H88.2314V14.8707H88.2305Z"
                                  fill="black"
                                />
                                    </svg>
                    </div> */}
                    <h2 className={styles.inputopmanerh}>Log in to Your Account</h2>
                    <p className={styles.inputopmaner}>to access Contact Center</p>
                    <div className={styles.inputopmanerprimary}>
                      <LoginSocialGoogle
                        client_id="672189196887-a63iclna3qh1145iousgui9ks1adgt1p.apps.googleusercontent.com"
                        scope="https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
                        redirect_uri="https://ccaas.worktual.co.uk/"
                        onResolve={async ({ provider, data }) => {
                          console.log(data, "data1245");
                          console.log(provider, "provider");
                          const email =
                            data?.email ||
                            data?.profile?.email ||
                            data?.profileObj?.email;


                          if (email) {
                            socialMediaLogin(email, "Google");
                          } else {
                            setLoader(false);
                            console.error(
                              "Email is undefined in the response",
                              data
                            );
                          }
                        }}
                        onReject={(err) => {
                          console.log("Error during authentication", err);
                        }}
                      >
                        <button className={styles.google}>
                          <img src={Google} alt="appleicon" /> {" "}
                          Continue with Google
                        </button>
                      </LoginSocialGoogle>
                      {/* <button className={styles.google}> <img src={Google} alt="appleicon" /> Continue with Google */}

                      {/* </button> */}
                      {/* <button className={styles.appleicon}> <img src={Microsoft} alt="appleicon" /> Continue with Microsoft</button> */}
                      {/* <button className={styles.microsofticon}> <img src={Apple} alt="microsofticon" /> Continue with Apple</button> */}
                      <LoginSocialMicrosoft

                        client_id="651c69df-eea7-4624-a1cf-cecdf82ec80e"
                        redirect_uri="https://ccaas.worktual.co.uk/"
                        onResolve={({ provider, data }: any) => {
                          console.log("data", data)
                          console.log("provider", provider)
                          const decodedToken: any = jwtDecode(data.access_token);
                          console.log("decoded token", decodedToken)
                          data.social_account_email = decodedToken.email;

                          data.social_account_email = data.mail ? data.mail : decodedToken.email ? decodedToken.email : decodedToken.unique_name;
                          data.social_account_type = "microsoft";

                          socialMediaLogin(data.social_account_email, "Microsoft");;
                        }}
                        onReject={(err) => {
                          console.log("iiiiiiiiii", err);
                        }}
                      >
                        <button className={styles.appleicon}>
                          <img src={Microsoft} alt="microsoft icon" />
                          Continue with Microsoft
                        </button>

                      </LoginSocialMicrosoft>
                  


                    <LoginSocialApple
                      client_id="com.worktual.login"
                      redirect_uri="https://ccaas.worktual.co.uk/"
                      onResolve={async ({ provider, data }: any) => {
                        console.log("data", data)
                        const decodedToken: any = jwtDecode(data.authorization.id_token);
                        console.log("decoded token", decodedToken)
                        data.social_account_email = decodedToken.email;
                        data.social_account_type = "Apple";
                        console.log("provider", provider)

                        const email = data.social_account_email || decodedToken?.email

                        console.log("Final Apple login object:", email);

                        await socialMediaLogin(email, "Apple");
                      }}
                      onReject={err => {
                        console.log(err);
                      }}
                    >
                      <button className={styles.microsofticon}> <img src={Apple} alt="microsofticon" /> Continue with Apple</button>
                    </LoginSocialApple>
                  </div>
                  <div className={styles.loginid}>
                    <p>or</p>
                  </div>
                  <div className={styles.inputdiv}>
                    <input
                      placeholder="Enter your E-mail"
                      name="email"
                      // className={styles.emailaddress}
                      value={login.email}
                      maxLength={100}
                      name="email"
                      onChange={onChangeInput}
                      autoFocus={true}
                    />
                    {login.email !== "" && (
                      <span className={`icon_closefill  ${styles.showClear}`} onClick={clearEmail}>
                        {" "}
                      </span>
                    )}
                    {error.email && <span className={`${styles.errorText} ${styles.invaliderrorText}`}>{login.errorMessage.emailError}</span>}
                  </div>
                  <div className={styles.inputdiv}>
                    <input
                      placeholder="Enter your password"
                      name="email"
                      // className={styles.emailaddresslock}   
                      value={login.password}
                      type={login.togglePass ? "input" : "password"}
                      name="password"
                      onChange={onChangeInput}
                      onKeyDown={(e: any) => handleEnter(e)}
                    />
                    {login.password !== "" && (
                      <span onClick={togglePassword}>
                        {!login.togglePass ? (
                          <svg
                            className="details_eyeicon__2Y-h8 details_eyeiconpassword__1ggc1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="13"
                            viewBox="0 0 20 13"
                            fill="none"
                          >
                            <path
                              d="M10 1.79307C13.4703 1.79307 16.6418 3.55157 18.4916 6.49957C16.6418 9.44757 13.4704 11.2061 10 11.2061C6.52965 11.2061 3.35805 9.44727 1.50845 6.49977C3.35805 3.55177 6.52955 1.79307 10 1.79307ZM10 0.292969C5.86775 0.292969 2.24915 2.47097 0.21525 5.73857C-0.07175 6.19947 -0.07175 6.79957 0.21525 7.26077C2.24915 10.5281 5.86775 12.7061 10 12.7061C14.1323 12.7061 17.7507 10.5281 19.7847 7.26077C20.0718 6.79957 20.0718 6.19947 19.7847 5.73857C17.7509 2.47097 14.1321 0.292969 10 0.292969Z"
                              fill="#788073"
                            />
                            <path
                              d="M9.99995 9.29557C11.5441 9.29557 12.7959 8.0438 12.7959 6.49967C12.7959 4.95553 11.5441 3.70377 9.99995 3.70377C8.45582 3.70377 7.20405 4.95553 7.20405 6.49967C7.20405 8.0438 8.45582 9.29557 9.99995 9.29557Z"
                              fill="#788073"
                            />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none" style={{width: '16px'}}><path d="M19.779 6.33692L17.6325 4.18992C18.4175 3.46582 19.119 2.63422 19.6936 1.68452C19.908 1.33002 19.7947 0.86912 19.4402 0.65422C19.0867 0.44032 18.6253 0.55362 18.4104 0.90712C16.6028 3.89442 13.4583 5.67762 9.99777 5.67762H9.99537C6.53737 5.67662 3.39527 3.89342 1.59057 0.90812C1.37527 0.55262 0.914271 0.44032 0.560271 0.65422C0.205771 0.86812 0.0924708 1.32902 0.306371 1.68352C0.880671 2.63372 1.58197 3.46572 2.36707 4.19032L0.220971 6.33682C-0.0720293 6.62982 -0.0720293 7.10442 0.220971 7.39732C0.367471 7.54382 0.559371 7.61702 0.751271 7.61702C0.943171 7.61702 1.13507 7.54382 1.28157 7.39732L3.54297 5.13562C4.39957 5.73572 5.33467 6.20642 6.32567 6.54672L5.66777 9.54382C5.57887 9.94912 5.83477 10.3485 6.23957 10.4374C6.29377 10.4491 6.34747 10.455 6.40067 10.455C6.74537 10.455 7.05597 10.2157 7.13257 9.86612L7.77557 6.93642C8.49897 7.08042 9.23687 7.17762 9.99487 7.17762H9.99777C10.7536 7.17762 11.4894 7.08142 12.2111 6.93832L12.8533 9.86602C12.93 10.2156 13.2405 10.4549 13.5852 10.4549C13.6384 10.4549 13.6921 10.449 13.7463 10.4373C14.1511 10.3484 14.4069 9.94902 14.3181 9.54372L13.6613 6.54962C14.6568 6.20932 15.5962 5.73712 16.4564 5.13462L18.7185 7.39732C18.865 7.54382 19.0569 7.61702 19.2488 7.61702C19.4407 7.61702 19.6326 7.54382 19.7791 7.39732C20.0721 7.10432 20.072 6.62982 19.779 6.33692Z" fill="#788073"></path></svg>
                        )}
                      </span>

                    )}

                    {error.password && <span className={`${styles.errorText}  ${styles.invaliderrorText}`}> {login.errorMessage.passWordError}</span>}
                  </div>
                  <div className={styles.lucasmaininput}>
                    <div className={styles.lucaslogin} style={{ justifyContent: "space-between" }}>
                  <label className="containercheckbox" onClick={rememberMe} style={{visibility:"hidden"}}>
                    <input type="checkbox" name="numberType" checked={login.remember} onChange={rememberMe}/>
                    Keep me login</label>
                    <p onClick={() => openForgotFlow()}><span>Forgot Password?</span></p>
                </div> 
                    {error.wholeError && <span className={`${styles.errorText} ${styles.valer}`}>{login.errorMessage.validationError}</span>}
                    {/* <button
                      className=''
                    >
                     Login
                    </button> */}
                    {!loading ?
                      <button onClick={SignIn} className={`${styles.btnSignin} ${loading ? "disabled" : ""}`}>
                        Login
                      </button>
                      :
                      <div className="spinloader"></div>
                    }
                    <p>Don't have a Worktual account yet?  <span onClick={redirectToWorktual}> Sign up</span></p>
                    <div className={styles.lucaslogin}>
                      {/* <label className="containercheckbox" onClick={rememberMe}>
                    <input type="checkbox" name="numberType" checked={login.remember} onChange={rememberMe}/>
                    Keep me login</label> */}
                      {/* <p onClick={() => window.open(`${process.env.REACT_APP_ENV === 'production' ? `https://myaccount.worktual.${domainExt}/forgotPassword` : `https://qa-myaccount.worktual.co.uk/forgotPassword`}`)}><span>Forget Password?</span></p> */}
                    </div>
                  </div>
                </div>
                {/* <div className={styles.stepercount}>
                 <p>Step of 4</p>
                </div> */}
              </div>
              </div>
            )}
       {login.isForgetPassword === "forget" && (
        <div className={styles.body}>
          <div className={styles.centeredcontent}>
            <div className={styles.lucasmain}>
              <h2 className={styles.inputopmanerh}>Forgot password?</h2>
              <p className={styles.inputopmaner}>
                Enter your registered email address and we&apos;ll send you an OTP
                to reset your password securely.
              </p>
     <div className={`${styles.inputdiv} ${styles.inputdivmail}`}>
                      <input
                        placeholder="Enter your E-mail"
                        maxLength={100}
                        value={forgotEmail}
                        onChange={(e) => {
                          setForgotEmail(e.target.value);
                          setForgotError("");
                        }}
                        autoFocus={true}
                      />
                      <span className={styles.msgicon}>
                        <img src={Messageicon} alt="Messageicon" />
                      </span>
                    </div>
              {forgotError ? (
                <div className={styles.errorfield}>
                  <span>{forgotError}</span>
                </div>
              ) : null}
              <div className={styles.lucasmaininput}>
                <button type="button" onClick={handleForgotSubmit}>
                  {forgotLoading ? "Please wait..." : "Confirm E-mail"}
                </button>
                <p>
                  Don&apos;t have a Worktual account yet?
                  <span > Sign up</span>
                </p>
                <p>
                  Already have an account?
                  <span onClick={() => backToLogin()}> Log In</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {login.isForgetPassword === "otp" && (
        <div className={styles.body}>
          <div className={styles.centeredcontent}>
            <div className={styles.lucasmain}>
              <h2 className={styles.inputopmanerh}>E-mail Verification</h2>
              <p className={styles.inputopmaner}>
                A verification code has been sent to you at{" "}
                <span className={styles.highlightedEmail}>{forgotEmail}</span>.
                Enter the code below.
              </p>
              <OTPInput value={otp} onChange={handleOTPChange} />
              {otpError ? (
                <div className={styles.errorfield}>
                  <span>{otpError}</span>
                </div>
              ) : null}
              <div className={`${styles.lucasmaininput} ${styles.lucasmaininputverify}`}>
                <button
                  type="button"
                  className={styles.confirmemailstep}
                  onClick={onVerifyOtp}
                >
                  {otpLoading ? "Verifying..." : "Verify"}
                </button>
                <button
                className={styles.changeemaill}
                  type="button"
                  onClick={() => openForgotFlow(forgotEmail)}
                >
                  Change E-mail
                </button>
                {otpMessage ? (
                  <p className={`${styles.resendemail} ${styles.resendemailmargin}`}>
                    {otpMessage}
                  </p>
                ) : null}
                <p className={`${styles.resendemail} ${styles.resendemailattempt}`}>
                  {Math.min(otpAttemptCount, OTP_MAX_ATTEMPTS)} / {OTP_MAX_ATTEMPTS} attempts -
                  <span className={styles.flowStaticText}> {formatTimer(otpResendTimer)}</span>{" "}
                  seconds remaining
                </p>
                <p className={styles.resendemail}>
                  Didn&apos;t receive the OTP?
                  <span
                    onClick={
                      otpResendTimer === 0 && otpAttemptCount < OTP_MAX_ATTEMPTS
                        ? onResendOtp
                        : undefined
                    }
                    className={
                      otpResendTimer === 0 && otpAttemptCount < OTP_MAX_ATTEMPTS
                        ? ""
                        : styles.resenddisabled
                    }
                  >
                    {" "}Resend
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {login.isForgetPassword === "update" && (
        <div className={styles.body}>
          <div className={styles.centeredcontent}>
            <div className={`${styles.lucasmain} ${styles.createnewpwmain}`} style={{position:"relative"}}>
              <h2 className={styles.inputopmanerh} style={{marginBottom:"20px"}}>Create New Password</h2>
              <div className={styles.inputblock}>
                <div className={`${styles.inputdiv} ${styles.flowFieldWithIcon}`}>
                  
                    {/* <span className={styles.flowFieldIcon}>
                    <img src={Lockicon} alt="Confirm password" />
                  </span> */}
                  <input
                    className={styles.flowInputWithIcon}
                    placeholder="Enter your new password"
                    autoComplete="new-password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setPasswordError("");
                    }}
                  />
                </div>
                {trimmedNewPassword.length > 0 ? (
                  <div className={styles.passwordStrengthWrap}>
                    <div className={`${styles.passwordStrengthMeter} ${passwordStrengthClass}`}>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    {passwordStrengthLabel ? (
                      <div className={`${styles.passwordStrengthText} ${passwordStrengthLabelClass}`}>
                        {passwordStrengthLabel}
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {trimmedNewPassword.length > 0 && passwordStrengthScore < 4 ? (
                  <div className={styles.passwordRules}>
                    <p className={`${styles.passwordRule} ${!isNoPersonalInfoRule ? styles.wrong : ""}`}>
                      <span className={styles.ruleStateIcon}>
                        {isNoPersonalInfoRule ? "✓" : "✕"}
                      </span>
                      Cannot contain your name or e-mail
                    </p>
                    <p className={`${styles.passwordRule} ${!isMinLengthRule ? styles.wrong : ""}`}>
                      <span className={styles.ruleStateIcon}>
                        {isMinLengthRule ? "✓" : "✕"}
                      </span>
                      At least 8 characters
                    </p>
                    <p className={`${styles.passwordRule} ${!isNumberOrSymbolRule ? styles.wrong : ""}`}>
                      <span className={styles.ruleStateIcon}>
                        {isNumberOrSymbolRule ? "✓" : "✕"}
                      </span>
                      Contains a number or symbol
                    </p>
                  </div>
                ) : null}
                <div className={`${styles.inputdiv} ${styles.flowFieldWithIcon}`}>
                  {/* <span className={styles.flowFieldIcon}>
                    <img src={Lockicon} alt="Confirm password" />
                  </span> */}
                  <input
                    className={styles.flowInputWithIcon}
                    placeholder="Confirm your password"
                    autoComplete="new-password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setPasswordError("");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onUpdatePassword();
                      }
                    }}
                  />
                  <span
                    className={styles.flowEyeToggle}
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  >
                    {!showConfirmPassword ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7.29356C15.4703 7.29356 18.6418 9.05206 20.4916 12.0001C18.6418 14.9481 15.4704 16.7066 12 16.7066C8.52965 16.7066 5.35805 14.9478 3.50845 12.0003C5.35805 9.05226 8.52955 7.29356 12 7.29356ZM12 5.79346C7.86775 5.79346 4.24915 7.97146 2.21525 11.2391C1.92825 11.7 1.92825 12.3001 2.21525 12.7613C4.24915 16.0286 7.86775 18.2066 12 18.2066C16.1323 18.2066 19.7507 16.0286 21.7847 12.7613C22.0718 12.3001 22.0718 11.7 21.7847 11.2391C19.7509 7.97146 16.1321 5.79346 12 5.79346Z" fill="#788073" />
                        <path d="M12 14.7961C13.5441 14.7961 14.7959 13.5443 14.7959 12.0002C14.7959 10.456 13.5441 9.20426 12 9.20426C10.4558 9.20426 9.20405 10.456 9.20405 12.0002C9.20405 13.5443 10.4558 14.7961 12 14.7961Z" fill="#788073" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.995 7.29397C15.465 7.29397 18.645 9.05377 20.485 12.004C19.705 13.244 18.695 14.274 17.525 15.044L18.595 16.1138C19.875 15.2339 20.955 14.084 21.785 12.7639C22.075 12.3037 22.075 11.7038 21.785 11.2439C19.745 7.97387 16.135 5.79387 11.995 5.79387C10.875 5.79387 9.79504 5.95377 8.77504 6.26387L9.99504 7.49387C10.645 7.36377 11.315 7.29397 11.995 7.29397Z" fill="#788073" />
                        <path d="M11.5249 9.02397L14.9749 12.484C15.0049 12.3238 15.0149 12.1639 15.0149 12.004C15.0149 10.3341 13.6649 8.98397 11.9949 8.98397C11.8349 8.98397 11.6749 8.99397 11.5249 9.02397Z" fill="#788073" />
                        <path d="M3.32464 2.22757C3.03214 1.93367 2.55754 1.93367 2.26414 2.22557C1.97074 2.51747 1.96974 2.99217 2.26214 3.28607L6.27564 7.31637C4.62444 8.26607 3.23084 9.62037 2.21494 11.2439C1.92494 11.7039 1.92494 12.3037 2.21494 12.7639C4.24494 16.0239 7.86494 18.2038 11.9949 18.2038C13.5183 18.2038 14.9622 17.9155 16.2875 17.3701L20.6717 21.7724C20.8182 21.9199 21.0106 21.9931 21.2029 21.9931C21.3943 21.9931 21.5857 21.9199 21.7322 21.7743C22.0257 21.4823 22.0266 21.0077 21.7342 20.7138L3.32464 2.22757ZM10.5408 11.5994L12.3916 13.4578C12.2678 13.502 12.1367 13.524 11.995 13.524C11.165 13.524 10.475 12.8341 10.475 12.004C10.475 11.8629 10.4971 11.7312 10.5408 11.5994ZM11.995 16.7039C8.52504 16.7039 5.35504 14.9439 3.50514 12.0039C4.48144 10.4495 5.81604 9.22407 7.37854 8.42377L9.40644 10.4599C9.13244 10.9067 8.97504 11.4306 8.97504 12.0038C8.97504 13.6637 10.335 15.0238 11.995 15.0238C12.5591 15.0238 13.0835 14.8661 13.5304 14.6012L15.1304 16.2079C14.1346 16.5348 13.0797 16.7039 11.995 16.7039Z" fill="#788073" />
                      </svg>
                    )}
                  </span>
                </div>
              </div>
              {passwordError ? (
                <div className={styles.errorfield}>
                  <span>{passwordError}</span>
                </div>
              ) : null}
              <div className={styles.lucasmaininput}>
                <button type="button" onClick={onUpdatePassword}>
                  {passwordLoading ? "Updating..." : "Create password"}
                </button>
                <p>
                  Once you&apos;ve set your new password, you can use it to log in
                  and reset it anytime in the settings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
    </>
  );
};
export default Login;

const handleAccountsuspended = async (token :any, userDetails :any, dispatch :any) => {
  try {
    return false
    const planCheck = await getSubscriptionManagement_Login(token, { "company_id": userDetails.company_id }, dispatch)
    console.log("planCheck>>>>",planCheck)
    if (!planCheck?.contract_end_date) {
      return false
    }
    const end = new Date(planCheck.contract_end_date);
    const today = new Date();
    if (isNaN(end.getTime())) {
      return false
    }
    end.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    if(end < today){
      return true
    }
    return false
  } catch (error) {
    return false
  }
}


export const getSubscriptionManagement_Login = async (accessToken:any, payload :any, dispatch: any) => {
  try {
      const url: any = config().CORESERVICE_URL;
      const response = await axios
          .post(`${url}${"/get_my_plans_subscription_management"}`,payload, {
              headers: {
              appId: config().APPID,
              appSecret: config().AppSECRET,
              Authorization: accessToken,
              },
          })
      if (response?.data?.result?.length > 0) {
          const res = response?.data?.result[0]
          dispatch(UserSettingsActions.setCompanyPlanDetails(res))
          return res;
      }
      return [];
  } catch (error) {
      console.log(error)
      return [];
  }
};